// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 rgba(0, 0, 0, 0.2);
  }
  50% {
    transform: scale(1.02);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.12);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 rgba(0, 0, 0, 0.2);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Categories/styles.css"],"names":[],"mappings":"AAAA;EACE;IACE,mBAAmB;IACnB,oCAAoC;EACtC;EACA;IACE,sBAAsB;IACtB,uCAAuC;EACzC;EACA;IACE,mBAAmB;IACnB,oCAAoC;EACtC;AACF","sourcesContent":["@keyframes pulse {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 rgba(0, 0, 0, 0.2);\n  }\n  50% {\n    transform: scale(1.02);\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.12);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 rgba(0, 0, 0, 0.2);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
